/* unplugin-vue-components disabled */import script from "./no-eat.vue?vue&type=script&setup=true&lang=ts"
export * from "./no-eat.vue?vue&type=script&setup=true&lang=ts"

import "./no-eat.vue?vue&type=style&index=0&id=170c897d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-170c897d"]])

export default __exports__